import React from 'react';
import PropTypes from 'prop-types';
import { ConfigContext } from 'store/context';
import { ConfigReducer } from 'store/reducers/ConfigReducer';
import useReducerWithLogger from './Logger';

function ConfigProvider({ children }) {
  const initData = {
    loading: false,
    message: '',
    statusCollapse: localStorage.getItem('sideBar') === 'true',
    hasSidebar: true,
    dashboardFilter: 'day',
    taxes: [],
    purchaseOrderDefaultTaxID: null,
  };
  const [ConfigState, ConfigDispatch] = useReducerWithLogger(ConfigReducer, initData);

  return (
    <ConfigContext.Provider
      value={{
        ConfigState,
        ConfigDispatch,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigProvider;
